<template>
    <div class="container-fluid">
        <el-container>
            <el-header height="15%">
                <div class="row mt-4">
                    <h4>Отзывы</h4>
                </div>
            </el-header>
            <el-main height="80%">
                <el-form aria-label="Поиск" label-width="140px" label-position="left">
                    <el-row>
                        <el-col :lg="12" :xl="8">
                            <el-form-item label="Поиск по товару">
                                <el-select v-model="query.product" clearable filterable @change="setQueryReset" placeholder="Выберите товар">
                                    <el-option
                                    v-for="item in products"
                                    :key="item.id"
                                    :label="item.title"
                                    :value="item.id">
                                    </el-option>
                                </el-select>


                            </el-form-item>
                        </el-col>
                        <el-col :lg="12" :xl="8">
                            <el-form-item label="Сортировка">
                                <el-select v-model="query.sort" :width="300" @change="setQuery" placeholder="сортировка">
                                    <el-option
                                    v-for="item in sortConfig"
                                    :key="item.field"
                                    :value="item.field"
                                    :label="item.title"
                                    />
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :lg="12" :xl="8">
                            <el-form-item label="Статус">
                                <el-select v-model="query.status" :width="300" @change="setQueryReset" placeholder="Статус">
                                    <el-option value="checked" label="Проверенные"></el-option>
                                    <el-option value="no_checked" label="Не проверенные"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>

                <el-table
                        :data="comments"
                        style="width: 100%"
                        empty-text="Нет отзывов">
                    <el-table-column
                            prop="id"
                            label="Id"
                            width="50">
                    </el-table-column>
                    <el-table-column prop="limitations"  type="expand">
                        <template slot-scope="props">
                            <el-row>
                                <el-col :span="2">
                                    Недостатки:
                                </el-col>
                                <el-col v-if="props.row.limitations" :span="18">
                                    {{props.row.limitations}}
                                </el-col>
                                <el-col :span="18" v-else>-</el-col>
                            </el-row>
                            <el-row >
                                <el-col :span="2">
                                    Достоинства:
                                </el-col>
                                <el-col v-if="props.row.dignities" :span="18">
                                    {{props.row.dignities}}
                                </el-col>
                                <el-col :span="18" v-else>-</el-col>
                            </el-row>
                        </template>
                    </el-table-column>
                    <el-table-column
                            prop="text"
                            label="Текст отзыва"
                            width="450"
                    >
                    </el-table-column>
                    <el-table-column
                            prop="user.full_name"
                            label="Пользователь"
                            >
                    </el-table-column>
                    <!-- <el-table-column
                            prop="product"
                            label="Товар"
                    >
                    </el-table-column> -->
                    <el-table-column
                            prop="stars"
                            label="Рейтинг"
                            width="150">
                    </el-table-column>
                    <el-table-column
                            prop="status"
                            label="Статус"
                    >
                    <template slot-scope="scope">
                        {{ scope.row.status === 'checked' ? 'Проверен' : 'Не проверен' }}
                    </template>
                    </el-table-column>
                    <el-table-column
                            fixed="right"
                            label="Действия"
                            width="300">
                        <template slot-scope="scope">
                            <el-button v-if="comments[scope.$index].status!=='checked'"
                                       type="success"
                                       size="mini"
                                       @click="Confirm(scope.$index)">Подтвердить</el-button>
                            <el-button v-if="comments[scope.$index].status!=='checked'"
                                       type="danger"
                                       size="mini"
                                       @click="Cancel(scope.$index)">Удалить</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </el-main>
            <el-footer height="5%">
                <el-pagination
                        background
                        layout="prev, pager, next"
                        :total="paginator.total"
                        :current-page.sync="paginator.current_page"
                        @current-change="getPage(paginator.current_page)"
                        :hide-on-single-page="true"
                        :page-size="paginator.per_page"
                        :page-count="paginator.last_page"
                >
                </el-pagination>
            </el-footer>
        </el-container>


    </div>
</template>

<script>
import axios from "axios";
import sortConfig from "../composable/config/review-sort.config"
import { SETPRELOADER_STATE } from '@/store/mutation-types'

export default {
    name: "Comments",
    data: function(){
        return{
            paginator: [],
            comments: [],
            status:0,
            message:'',
            sortConfig,
            query:{
                product:'',
                sort: sortConfig[0].field,
                status: '',
                page: 1,
            },
            products: []

        }
    },
    mounted() {
        this.initParams(this.$route.query);
        this.getComments(this.getQuery(this.getQueryObj().obj));
        this.getProducts();
    },
    watch:{
    '$route.query'(v){   
            const query = this.getQuery(v)   
            if (query){              
                this.getComments(query)
            }
        }
    },
    computed: {
        activeSort() {
            const result = this.sortConfig.find((e) => e.field === this.query.sort)
            return result ? result.options  : undefined
        },
    },
    methods:{
        getProducts(){
          axios.get('review/products').then((response)=>{
             this.products = response.data;
          }).catch((errors)=>{
              if(errors.response.status === 401){
                  this.$router.push('/login');
              }
          });
        },
        getComments(query){
            this.$store.commit(SETPRELOADER_STATE, true)                      
            axios.get('review' + query).then((response)=>{
                this.paginator = response.data.meta;
                this.comments = response.data.data;
            }).catch((errors)=>{
                if(errors.response.status === 401){
                    this.$router.push('/login');
                }
            })
            .finally(() => this.$store.commit(SETPRELOADER_STATE, false));
        },
        Confirm(index){
            let id = this.comments[index].id;
            axios.post('/review/'+id+'/confirm').then(()=>{
                this.$notify.success('Отзыв подтвержден')
                this.getComments();
            }).catch((errors)=>{
                if(errors.response.status === 401){
                    this.$router.push('/login');
                }
                this.$notify.error('Не предвиденная ошибка')
            });
        },
        Cancel(index){
            let id = this.comments[index].id;
            axios.delete('review/'+id).then(()=>{
                this.$notify.success('Отзыв удален')
                this.getComments();
            }).catch((errors)=>{
                if(errors.response.status === 401){
                    this.$router.push('/login');
                }
                this.$notify.error('Не предвиденная ошибка')
            });
        },
        getPage: function(pageNum){
            if(pageNum!==null){
                this.query.page = pageNum
                this.setQuery()
            }
        },

        setQueryReset(){
            this.query.page = 1
            this.setQuery()
        },
        getQueryObj(){
            const result = {};
            let isChange = false;
            
            if (this.activeSort) {
                isChange = true;
                result['sort']= {
                    by: this.activeSort.by,
                    order: this.activeSort.order
                }       
            }
            if (this.query.status) {
                isChange = true;
                result['status']=this.query.status
            }
            if(this.query.product){
                result['product_id']=this.query.product
            }
            if(this.query.page){
                isChange = true
                result['page']=this.query.page
            }

            return {
                isChange,
                obj: result,
            }
        },
        setQuery(){
            const result = this.getQueryObj();

            if (result.isChange) {
            const q = this.getQuery(result.obj)
                this.$router.push({
                    path: 'reviews' + q,
                })
            }
        }, 
        getQuery(query) {
            if (Object.keys(query).length > 0){        
            const qs = require('qs');
            return `?${qs.stringify(query)}`
            }
            return ''
        },
        initParams(query){
            if (!query){
            return
            }
            const qs = require('qs');
            const parseQuery= qs.parse(query);

            if (parseQuery.sort?.by && parseQuery.sort?.order) {
                this.query.sort = `${parseQuery.sort.by}.${parseQuery.sort.order}`
            }
            if (parseQuery.q){
            this.query.status = parseQuery.status
            }
            if(parseQuery.product_id){
            this.query.product= parseQuery.product_id
            }
            if(parseQuery.page){
                this.query.page = parseQuery.page
            }
        }
    }
}
</script>

<style scoped>

</style>